import * as React from "react";
import { SVGProps } from "react";
const SvgShoppingCart = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29.28 7.9c-.2-.2-.5-.4-.8-.4H9.28l-.8-3.2c-.1-.5-.5-.8-1-.8h-4c-.6 0-1 .4-1 1s.4 1 1 1h3.2l3.8 15.2c.1.5.5.8 1 .8h13c.4 0 .8-.3 1-.7l4-12c.1-.3 0-.6-.2-.9Zm-5.5 11.6h-11.5l-1-4h13.8l-1.3 4Zm2-6h-15l-1-4h17.3l-1.3 4ZM16.48 26c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5Zm9 0c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShoppingCart;
